import script from "./LocateMe.vue?vue&type=script&setup=true&lang=js"
export * from "./LocateMe.vue?vue&type=script&setup=true&lang=js"

import "./LocateMe.vue?vue&type=style&index=0&id=af6e33e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af6e33e2"]])

export default __exports__